import { Image as ImageIcon } from 'lucide-react';
import { useI18n } from '@/providers/i18n';
import { ReminderDialog } from './reminder-dialog';

type TextModeImageDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** 'image' = 图像节点（文生图）；'video' = 视频节点（文生视频）。仅影响文案。 */
  mediaKind: 'image' | 'video';
  /** 保持文生模式、忽略上游图片继续生成。 */
  onKeep: () => void;
  /** 切换到图生模式后再生成。 */
  onSwitch: () => void;
};

/**
 * 上游连了图片但当前是「文生」模式（图片会被忽略）时的统一提醒弹窗，图像/视频节点共用。
 */
export function TextModeImageDialog({ open, onOpenChange, mediaKind, onKeep, onSwitch }: TextModeImageDialogProps) {
  const { t } = useI18n();
  const isVideo = mediaKind === 'video';
  return (
    <ReminderDialog
      open={open}
      onOpenChange={onOpenChange}
      icon={<ImageIcon size={16} className="text-primary" />}
      title={t('Upstream image detected')}
      description={
        isVideo
          ? t("You've connected an image, but the current mode is Text to Video, so the image will be ignored. Switch to Image to Video?")
          : t("You've connected an image, but the current mode is Text to Image, so the image will be ignored. Switch to Image to Image?")
      }
      actions={[
        {
          label: isVideo ? t('Keep Text to Video') : t('Keep Text to Image'),
          variant: 'outline',
          onClick: onKeep,
        },
        {
          label: isVideo ? t('Switch to Image to Video') : t('Switch to Image to Image'),
          onClick: onSwitch,
        },
      ]}
    />
  );
}
